import React from "react";
import { PageProps } from "@sdflc/react-router-pages";
import { FullScreenLayout } from "../../../components/layouts/FullScreenLayout";
import { useParams } from "react-router-dom";
import { DisplayView } from "@/components/features";

interface DisplayPreviewPageParams extends Record<string, string | undefined> {
  displayId: string;
}

export const DisplayPreviewPage: React.FC<PageProps> = (props: PageProps) => {
  const { displayId } = useParams<DisplayPreviewPageParams>();

  return (
    <FullScreenLayout {...props}>
      {displayId && <DisplayView displayId={displayId} preview={true} />}
    </FullScreenLayout>
  );
};
